module.exports = __webpack_public_path__ + "static/media/icon-cta-plus-dark.fdfea152.svg";